import { render, staticRenderFns } from "./RealizarManifestacao.vue?vue&type=template&id=e52b4c10&"
import script from "./RealizarManifestacao.vue?vue&type=script&lang=js&"
export * from "./RealizarManifestacao.vue?vue&type=script&lang=js&"
import style0 from "./RealizarManifestacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports